"use client";

import { useRef } from "react";

import styles from "./SpotlightHeading.module.css";

// A heading whose blue gradient "spotlight" follows the cursor. Wrap the words
// that should glow in <SpotlightWord>; surrounding text keeps its own color.
//
// On mousemove we update --mx/--my on EACH SpotlightWord relative to its own box
// (not the container), because background-clip:text positions the radial gradient
// against the element's own background area. This keeps the spotlight continuous
// across words even when they sit on different lines. When the cursor leaves, the
// spotlight stays at its last position. Small client island so consumers can stay
// Server Components.
export default function SpotlightHeading({
  as: Tag = "h2",
  children,
  className = "",
  ...rest
}) {
  const ref = useRef(null);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const words = el.querySelectorAll(
      `.${styles.spotlightWord}, .${styles.gradientWord}`,
    );
    words.forEach((word) => {
      const rect = word.getBoundingClientRect();
      word.style.setProperty("--mx", `${e.clientX - rect.left}px`);
      word.style.setProperty("--my", `${e.clientY - rect.top}px`);
    });
  };

  return (
    <Tag ref={ref} onMouseMove={handleMove} className={className} {...rest}>
      {children}
    </Tag>
  );
}

// A word/phrase that gets the spotlight gradient. Must live inside a
// SpotlightHeading for the cursor tracking to reach it.
//
// `variant="gradient"` swaps the resting look for the drifting brand ramp — use
// it where the word has to announce itself to a reader who never moves the
// mouse over it. Both variants track the cursor; see the module CSS.
export function SpotlightWord({ children, className = "", variant = "spot" }) {
  const tone =
    variant === "gradient" ? styles.gradientWord : styles.spotlightWord;
  return <span className={`${tone} ${className}`}>{children}</span>;
}
